import { render, staticRenderFns } from "./SendZns.vue?vue&type=template&id=586adb86&scoped=true"
import script from "./SendZns.vue?vue&type=script&lang=js"
export * from "./SendZns.vue?vue&type=script&lang=js"
import style0 from "./SendZns.vue?vue&type=style&index=0&id=586adb86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586adb86",
  null
  
)

export default component.exports